import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreenB } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'CUPONS_INDEX',
    STORE: 'CUPONS_STORE',
    UPDATE: 'CUPONS_UPDATE',
    DESTROY: 'CUPONS_DESTROY',
    CHANGE: 'CUPONS_CHANGE',
    SUCCESS: 'CUPONS_SUCCESS',
    ERROR: 'CUPONS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (query) => dispatch => {
    return HttpAuth.get('/cupons?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
            .catch(erro => {
                if(erro.response) {
                    if(erro.response.data.msg) {
                        dispatch(changeAlert({
                            open: true,
                            msg: erro.response.data.msg,
                            class: 'error'
                        }))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
}

// STORE

export const store = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/cupons', data)
    .then(res => {
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(change('clear'))
                dispatch(index({campaign_id: data.campaign_id})).then(e => dispatch(changeLoading({ open: false })))
                dispatch(changeScreenB({ open: false }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
            if(erro.response.data.errors) {
                dispatch(error(erro.response.data.errors))
                let res = erro.response.data.errors[Object.keys(erro.response.data.errors)[0]]
                if(res[0]) {
                    dispatch(changeAlert({
                        open: true,
                        msg: res[0],
                        class: 'error'
                    }))
                }
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/cupons/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/cupons/'+data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(index({rifa_id: data.campaign_id}))
                    dispatch(changeScreenB({ open: false }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('/cupons/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(destroyResponse(id))
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        })
}